import { filtrarPorEmpresa } from 'src/app/pipes/empresa-cuenta.pipe';

// Cuentas de destino (Mario, 4-nov: «el filtro de cuentas solo lo tenga alguien al que se le asigne un permiso, y por defecto
// siempre solo las de CT porque ya estamos migrados»). Sin el permiso no hay chips ni manera de ver cuentas MT; con él, los
// chips Todas / MT / CT y el filtro arranca en CT. Ya no depende del switch.
const esCT = (v: any) => String(v ?? '').trim().toUpperCase() === 'CT';

export type FiltroEmpresa = 'CrediTotal' | 'Mundo Total' | 'Todas';

/** Permiso para ver (y filtrar) las cuentas de Mundo Total al elegir la cuenta destino. */
export const PERMISO_VER_CUENTAS_MT = 'pagos.cuentas_destino.ver_mt';

/** El filtro siempre arranca en CrediTotal. */
export const FILTRO_INICIAL: FiltroEmpresa = 'CrediTotal';

// Misma regla que empresaDeCuenta (pipes/empresa-cuenta.pipe): CT si perfil o empresa es 'CT'
const empresaDe = (c: any) => (esCT(c?.perfil) || esCT(c?.empresa) ? 'CrediTotal' : 'Mundo Total');

/** Cuentas que se muestran: sin permiso solo las CT, diga lo que diga el filtro; con permiso, las del filtro. */
export const cuentasDestino = (cuentas: any[], filtro: string, puedeVerMT: boolean) =>
  filtrarPorEmpresa(cuentas || [], puedeVerMT ? filtro : 'CrediTotal');

/** Copia con las cuentas de la empresa elegida primero; dentro de cada grupo, el orden que traían. */
export const activasPrimero = (cuentas: any[], empresa: string) => {
  const lista = [...(cuentas || [])];
  if (empresa !== 'CrediTotal' && empresa !== 'Mundo Total') return lista;
  return [...lista.filter((c: any) => empresaDe(c) === empresa), ...lista.filter((c: any) => empresaDe(c) !== empresa)];
};
